var paragraph_default = {
  "fontElementMap": "VxANe",
  "elementSpacing": "TVrbu",
  "text": "tQpTW TVrbu",
  "child": "UPtM1"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
